import { useRef } from "react";

import FeatureList from "@/components/feature-list";
import useInView from "@/hooks/use-in-view";
import type { IFeatures } from "@/lib/types";

function FeatureRow({
  eyebrow,
  heading,
  description,
  items,
  image,
  imagePosition,
}: Readonly<IFeatures>) {
  const isImageLeft = imagePosition === "left";

  const rowRef = useRef<HTMLDivElement>(null);
  const inView = useInView(rowRef);

  const imageEl = (
    <div>
      <img
        loading="lazy"
        src={image}
        alt="App demo"
        className="h-auto w-full sm:w-86"
      />
    </div>
  );

  const textEl = (
    <div className="flex-gap-md flex   w-full max-w-110 flex-col px-5 sm:px-0 lg:text-left">
      <p className="eyebrow">{eyebrow}</p>
      <h2 className=" text-3xl font-normal sm:text-5xl">{heading}</h2>
      <p className="body-text">
        {description}
      </p>
      <ul className="flex flex-col gap-3 text-[#2b2c30]">
        {items.map((item) => (
          <FeatureList key={item} feature={item} />
        ))}
      </ul>
    </div>
  );

  return (
    <div
      ref={rowRef}
      className={`feature-row feature-reveal ${inView ? "in-view" : ""} ${isImageLeft ? "flex-col-reverse lg:flex-row" : "flex-col lg:flex-row"}`}
    >
      {isImageLeft ? (
        <>
          {imageEl}
          {textEl}
        </>
      ) : (
        <>
          {textEl}
          {imageEl}
        </>
      )}
    </div>
  );
}

export default FeatureRow;
